import { useMemo, useState } from 'react';
import box from '~/assets/icons/box_2.svg';
import category from '~/assets/icons/category_2.svg';
import heart from '~/assets/icons/heart.svg';
import plusRound from '~/assets/icons/plus_round.svg';
import sort from '~/assets/icons/sort.svg';
import { Text } from '~/components/ui/Text';
import { Apps, VehicleNumberPlateType } from '~/shared';
import {
	setActiveFilter,
	setCategorySelectVisible,
	setItemPageVisible,
	setItemType,
	setModelFilter,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { AppAdsFilter, AppAdsPages, AppAdsTypes } from '../AppAds';
import { DefaultAppItemCard } from '../DefaultAppItemCard';
import { Select } from '../Select';
import {
	filterCarModelItems,
	filterClothesTypeItems,
	filterOtherTypeItems,
	filterRealtyTypeItems,
	filterSelectItems,
	sortSelectItems,
} from './AppAdsItemsPage.model';
import {
	StyledContainer,
	StyledCreateButton,
	StyledFiltersContainer,
	StyledHead,
	StyledHeadItemsContainer,
	StyledHeadTitleContainer,
	StyledItemsGrid,
} from './AppAdsItemsPage.styled';

const AppAdsItemsPage = () => {
	const dispatch = useLayoutDispatch();
	const activePage = useLayoutSelector((state) => state.ads.activePage);
	const activeFilter = useLayoutSelector((state) => state.ads.activeFilter);
	const activeCarModelFilter = useLayoutSelector(
		(state) => state.ads.activeCarModelFilter,
	);
	const activeRealtyTypeFilter = useLayoutSelector(
		(state) => state.ads.activeRealtyTypeFilter,
	);
	const activeClothesTypeFilter = useLayoutSelector(
		(state) => state.ads.activeClothesTypeFilter,
	);
	const activeOtherTypeFilter = useLayoutSelector(
		(state) => state.ads.activeOtherTypeFilter,
	);
	const [sortValue, setSortValue] = useState<string | number | null>(null);

	const selectValue = useMemo(
		() => (activeFilter === AppAdsFilter.Main ? null : activeFilter),
		[activeFilter],
	);

	return (
		<StyledContainer>
			<StyledHead>
				<StyledHeadItemsContainer>
					{activePage !== AppAdsPages.Main && (
						<StyledHeadTitleContainer
							style={{
								backgroundColor:
									activePage === AppAdsPages.Favorites
										? '#C71E1E'
										: 'rgba(255, 255, 255, 0.05)',
							}}
						>
							<img src={activePage === AppAdsPages.Favorites ? heart : box} />
							<Text>
								{activePage === AppAdsPages.Favorites
									? 'Избранное'
									: 'Мои товары'}
							</Text>
						</StyledHeadTitleContainer>
					)}
					<StyledFiltersContainer>
						{activeFilter === AppAdsFilter.Main && (
							<Select
								items={filterSelectItems}
								value={selectValue}
								placeholder={'Выбрать категорию'}
								onChange={(value) => {
									dispatch(setActiveFilter(value.value));
								}}
								icon={category}
							/>
						)}
						{activeFilter === AppAdsFilter.Vehicle && (
							<Select
								items={filterCarModelItems}
								value={activeCarModelFilter}
								placeholder={'Выберите марку'}
								onChange={(value) => {
									dispatch(
										setModelFilter({
											type: AppAdsTypes.Vehicle,
											value: value.value as string,
										}),
									);
								}}
								icon={category}
							/>
						)}
						{activeFilter === AppAdsFilter.Realty && (
							<Select
								items={filterRealtyTypeItems}
								value={activeRealtyTypeFilter}
								placeholder={'Выберите тип'}
								onChange={(value) => {
									dispatch(
										setModelFilter({
											type: AppAdsTypes.Realty,
											value: value.value as string,
										}),
									);
								}}
								icon={category}
							/>
						)}
						{activeFilter === AppAdsFilter.Clothes && (
							<Select
								items={filterClothesTypeItems}
								value={activeClothesTypeFilter}
								placeholder={'Выберите тип'}
								onChange={(value) => {
									dispatch(
										setModelFilter({
											type: AppAdsTypes.Clothes,
											value: value.value as string,
										}),
									);
								}}
								icon={category}
							/>
						)}
						{activeFilter === AppAdsFilter.Other && (
							<Select
								items={filterOtherTypeItems}
								value={activeOtherTypeFilter}
								placeholder={'Выберите тип'}
								onChange={(value) => {
									dispatch(
										setModelFilter({
											type: AppAdsTypes.Other,
											value: value.value as string,
										}),
									);
								}}
								icon={category}
							/>
						)}
						<Select
							items={sortSelectItems}
							value={sortValue}
							placeholder={'Сортировать'}
							onChange={(value) => {
								setSortValue(value.value);
							}}
							icon={sort}
						/>
					</StyledFiltersContainer>
				</StyledHeadItemsContainer>
				<StyledHeadItemsContainer>
					{/* {activePage === AppAdsPages.Main && (
						<StyledFavoriteButton
							onClick={() => dispatch(setActivePage(AppAdsPages.Favorites))}
						>
							<img src={heart} />
						</StyledFavoriteButton>
					)} */}
					<StyledCreateButton
						onClick={() => dispatch(setCategorySelectVisible(true))}
					>
						<img src={plusRound} />
					</StyledCreateButton>
				</StyledHeadItemsContainer>
			</StyledHead>
			<StyledItemsGrid>
				{new Array(16).fill(0).map((_, i) => (
					<DefaultAppItemCard
						appType={Apps.Ads}
						type={
							i < 5
								? AppAdsTypes.Vehicle
								: i < 10
								? AppAdsTypes.Realty
								: i < 13
								? AppAdsTypes.Clothes
								: AppAdsTypes.Other
						}
						gold={i % 4 === 0}
						vehicleNumberPlate={{
							type: VehicleNumberPlateType.Classic,
							text: 'A111AA',
							region: '38',
						}}
						price={100000}
						time={12345}
						priceFrom={true}
						onClick={() => {
							dispatch(setItemType(AppAdsTypes.Vehicle));
							dispatch(setItemPageVisible(true));
						}}
						key={i}
					/>
				))}
			</StyledItemsGrid>
		</StyledContainer>
	);
};

export { AppAdsItemsPage };
